<template lang="">
  <div class="flex gap-2">
    <label v-if="label" for="hs-color-input" class="block text-sm font-medium mb-2">{{ label }}</label>
    <input
      id="hs-color-input"
      v-model="currentColor"
      type="color"
      class="p-1 h-10 w-14 block bg-white border border-gray-200 w-10 rounded-md disabled:opacity-50"
      :class="{ '!cursor-not-allowed': disabled, 'cursor-pointer': !disabled }"
      :disabled="disabled"
      style="outline: none"
    />
    <input
      v-model="currentColor"
      class="py-2 px-3 transition-all block w-full rounded-md focus:ring-blue-500 text-md border border-gray-200"
      @blur="handleBlur"
    />
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: "#000",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      currentColor: "",
    };
  },
  watch: {
    currentColor(n) {
      this.$emit("input", n);
      this.$emit("change", n);
    },
  },
  created() {
    this.currentColor = this.value;
  },
  methods: {
    handleBlur() {
      if (!this.isValidColor(this.currentColor)) {
        this.currentColor = "#000";
      }
    },
    isValidColor(color) {
      const el = new Option().style;
      el.color = color;
      return el.color !== "";
    },
  },
};
</script>

<style lang="scss"></style>
